export default "__VITE_ASSET__CxAbhkL___"